import {
  affineInlineMarkdownMatches,
  type AffineTextAttributes,
  getAffineInlineSpecsWithReference,
  InlineManager,
  ReferenceNodeConfig,
} from '@blocksuite/affine-components/rich-text';
import { BlockService } from '@blocksuite/block-std';

import { DatabaseSelection } from '../database-block/data-view/index.js';
import type { DataViewBlockModel } from './data-view-model.js';

export class DataViewBlockService<
  TextAttributes extends AffineTextAttributes = AffineTextAttributes,
> extends BlockService<DataViewBlockModel> {
  readonly inlineManager = new InlineManager<TextAttributes>();

  readonly referenceNodeConfig = new ReferenceNodeConfig();

  override mounted(): void {
    super.mounted();
    this.selectionManager.register(DatabaseSelection);

    this.referenceNodeConfig.setDoc(this.doc);

    const inlineSpecs = getAffineInlineSpecsWithReference(
      this.referenceNodeConfig
    );
    this.inlineManager.registerSpecs(inlineSpecs);
    this.inlineManager.registerMarkdownMatches(affineInlineMarkdownMatches);
  }
}
